"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.getSecp256k1Instance = exports.setSecp256k1Instance = exports.Decred = exports.ViaCoin = exports.Vertcoin = exports.Qtum = exports.Doge = exports.BitcoinGold = exports.Stealth = exports.Stakenet = exports.Pivx = exports.Komodo = exports.Peercoin = exports.Dash = exports.Zen = exports.Zec = exports.Digibyte = exports.Litecoin = exports.BitcoinCash = exports.Bitcoin = void 0;
var bitcoin_1 = require("./bitcoin");
__createBinding(exports, bitcoin_1, "default", "Bitcoin");
var bitcoincash_1 = require("./bitcoincash");
__createBinding(exports, bitcoincash_1, "default", "BitcoinCash");
var litecoin_1 = require("./litecoin");
__createBinding(exports, litecoin_1, "default", "Litecoin");
var digibyte_1 = require("./digibyte");
__createBinding(exports, digibyte_1, "default", "Digibyte");
var zec_1 = require("./zec");
__createBinding(exports, zec_1, "default", "Zec");
var zen_1 = require("./zen");
__createBinding(exports, zen_1, "default", "Zen");
var dash_1 = require("./dash");
__createBinding(exports, dash_1, "default", "Dash");
var peercoin_1 = require("./peercoin");
__createBinding(exports, peercoin_1, "default", "Peercoin");
var komodo_1 = require("./komodo");
__createBinding(exports, komodo_1, "default", "Komodo");
var pivx_1 = require("./pivx");
__createBinding(exports, pivx_1, "default", "Pivx");
var stakenet_1 = require("./stakenet");
__createBinding(exports, stakenet_1, "default", "Stakenet");
var stealth_1 = require("./stealth");
__createBinding(exports, stealth_1, "default", "Stealth");
var bitcoingold_1 = require("./bitcoingold");
__createBinding(exports, bitcoingold_1, "default", "BitcoinGold");
var doge_1 = require("./doge");
__createBinding(exports, doge_1, "default", "Doge");
var qtum_1 = require("./qtum");
__createBinding(exports, qtum_1, "default", "Qtum");
var vtc_1 = require("./vtc");
__createBinding(exports, vtc_1, "default", "Vertcoin");
var via_1 = require("./via");
__createBinding(exports, via_1, "default", "ViaCoin");
var decred_1 = require("./decred");
__createBinding(exports, decred_1, "default", "Decred");
var secp256k1_1 = require("./secp256k1");
__createBinding(exports, secp256k1_1, "setSecp256k1Instance");
__createBinding(exports, secp256k1_1, "getSecp256k1Instance");
//# sourceMappingURL=index.js.map